import { INFO_REQUESTED_STATUS, isSalesCycleStatus } from './partnerProjectStatusUtils';
import { PARTNER_PRIMARY_STATUSES } from '../Constants/partnerStatuses';

export const MY_PROJECTS_STAT_FILTER_ALL = 'all';

export const MY_PROJECTS_STAT_CARD_FILTERS = {
  ALL: MY_PROJECTS_STAT_FILTER_ALL,
  ACTIVE: PARTNER_PRIMARY_STATUSES.ACTIVE,
  SALES_CYCLE: PARTNER_PRIMARY_STATUSES.NOT_STARTED,
  INFO_REQUESTED: INFO_REQUESTED_STATUS,
  COMPLETED: PARTNER_PRIMARY_STATUSES.COMPLETED,
};

export const matchesMyProjectsStatFilter = (project, statusFilter) => {
  if (!statusFilter || statusFilter === MY_PROJECTS_STAT_FILTER_ALL) {
    return true;
  }

  const projectStatus = String(project?.projectStatus || '').trim();

  switch (statusFilter) {
    case MY_PROJECTS_STAT_CARD_FILTERS.ACTIVE:
      return projectStatus === MY_PROJECTS_STAT_CARD_FILTERS.ACTIVE;
    case MY_PROJECTS_STAT_CARD_FILTERS.SALES_CYCLE:
      return projectStatus === MY_PROJECTS_STAT_CARD_FILTERS.SALES_CYCLE
        || isSalesCycleStatus(projectStatus);
    case MY_PROJECTS_STAT_CARD_FILTERS.INFO_REQUESTED:
      return projectStatus === MY_PROJECTS_STAT_CARD_FILTERS.INFO_REQUESTED;
    case MY_PROJECTS_STAT_CARD_FILTERS.COMPLETED:
      return projectStatus === MY_PROJECTS_STAT_CARD_FILTERS.COMPLETED;
    default:
      return projectStatus === statusFilter;
  }
};

export const countMyProjectsStatCards = (projects = []) => (
  projects.reduce((accumulator, project) => {
    const projectStatus = String(project?.projectStatus || '').trim();

    if (projectStatus === MY_PROJECTS_STAT_CARD_FILTERS.ACTIVE) {
      accumulator.active += 1;
    } else if (
      projectStatus === MY_PROJECTS_STAT_CARD_FILTERS.SALES_CYCLE
      || isSalesCycleStatus(projectStatus)
    ) {
      accumulator.salesCycle += 1;
    } else if (projectStatus === MY_PROJECTS_STAT_CARD_FILTERS.INFO_REQUESTED) {
      accumulator.infoRequested += 1;
    } else if (projectStatus === MY_PROJECTS_STAT_CARD_FILTERS.COMPLETED) {
      accumulator.completed += 1;
    }

    return accumulator;
  }, {
    total: projects.length,
    active: 0,
    salesCycle: 0,
    infoRequested: 0,
    completed: 0,
  })
);
